import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=cf3add64&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3add64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf3add64')) {
      api.createRecord('cf3add64', component.options)
    } else {
      api.reload('cf3add64', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=cf3add64&scoped=true&", function () {
      api.rerender('cf3add64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2can4wr2GjZRW/JS/comp/Accordion.vue"
export default component.exports